import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button, Select, MenuItem, FormControl, InputLabel, Tooltip } from '@material-ui/core';
import CloseIcon from '../../components/svg/closeIcon';
import InfoIcon from '../../components/svg/infoIcon.svg';
import CallIcon from '../../components/svg/call.svg';
import VideoIcon from '../../components/svg/video.svg';
import './MeetingSummaryModal.css';
import { getMeetingSummary, saveMeetingSummary } from '../../modals';
import { format, parse, set } from 'date-fns';
import { useHistory } from 'react-router';
import MettingIncompleteDialog from './MeetingIncompleteDialog';
import UnsavedChangesDialog from './UnsavedChangesDialog';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '600px',
    padding: '0px',
    borderRadius: '25px',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: '20',
  },
};

Modal.setAppElement('#root');

const calculateDuration = (timeRange) => {
  if (!timeRange) return '0 min';
  const [startTime, endTime] = timeRange.split(' - ');
  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);

  const totalStartMins = startHour * 60 + startMin;
  const totalEndMins = endHour * 60 + endMin;
  const diffMins = totalEndMins - totalStartMins;

  if (diffMins < 60) {
    return `${diffMins} min`;
  }
  const hours = Math.floor(diffMins / 60);
  return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
};

const formatTimeRange = (timeRange) => {
  if (!timeRange) return ' - ';
  const [startTime, endTime] = timeRange.split(' - ');
  const formatTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));
    return format(date, 'h:mma').toLowerCase();
  };
  return `${formatTime(startTime)} - ${formatTime(endTime)}`;
};

function MeetingSummaryModal({ onClose, meetingSummaryFieldsData, meetingId, isEdit, dotFlag }) {
  const history = useHistory();
  const [showIncompleteDialog, setShowIncompleteDialog] = useState(false);
  const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const userinfo = JSON.parse(localStorage.getItem('userinfo'));
  const counselorName = `${userinfo.firstName} ${userinfo.middleName || ""} ${userinfo.lastName || ""}`;
  let { attendance = [], serviceProvider = [], nextMeeting = [], meetingLanguage = [], formProvider, meetingType = [] } = meetingSummaryFieldsData || {};
  attendance = !attendance ? [] : attendance;
  serviceProvider = !serviceProvider ? [] : serviceProvider;
  nextMeeting = !nextMeeting ? [] : nextMeeting;
  meetingLanguage = !meetingLanguage ? [] : meetingLanguage;
  formProvider = !formProvider ? [] : formProvider;
  meetingType = !meetingType ? [] : meetingType;
  const [counselingSession, setCounselingSession] = useState({
    counselor: counselorName,
    meetingReason: "1",
    meetingLanguage: "1",
    studentAttendance: 1,
    serviceProvided: [],
    formProvided: [],
    tasksForNextMeeting: [],
    notes: {
      toStudent: null,
      toCounselors: null
    }
  });
  const { studentDetail = [], meetingDate, startAndEndTime, meetingStartTime, meetingEndTime, meetingType: meetingType1, serviceProvidedDetails = [], tasksForNextMeetingDetails = [], formProvidedDetails = [] } = counselingSession;
  const [editMode, setEditMode] = useState(!dotFlag);
  const { fullName, studentId } = studentDetail[0] || {};
  const columns2Disable = [2, 3].includes(counselingSession.studentAttendance);
  const isNotComplete = !counselingSession.studentAttendance || counselingSession.studentAttendance === 1 && (!counselingSession.serviceProvided.length || !counselingSession.formProvided.length || !counselingSession.tasksForNextMeeting.length);
  const handleAttendanceChange = (id) => {
    setCounselingSession(prev => ({
      ...prev,
      studentAttendance: id,
      ...([2, 3].includes(id) ? { serviceProvided: [], formProvided: [], tasksForNextMeeting: [] } : {})
    }));
  };

  const handleCheckboxChange = (section, id, value) => {
    setCounselingSession(prev => {
      let updatedValues = [...prev[section]];

      const isChecked = updatedValues.includes(id);

      if (value === "None") {
        // If "None" is being selected, clear all other values and keep only "None"
        updatedValues = isChecked ? [] : [id];
      } else {
        // If another value is selected, remove "None" if present
        if (section === 'formProvided' || section === 'tasksForNextMeeting')
          updatedValues = updatedValues.filter(item => item !== 3);

        if (isChecked) {
          updatedValues = updatedValues.filter(item => item !== id); // unchecking
        } else {
          updatedValues.push(id); // checking
        }
      }

      return {
        ...prev,
        [section]: updatedValues
      };
    });
  };


  const handleNotesChange = (type, value) => {
    setCounselingSession(prev => ({
      ...prev,
      notes: {
        ...prev.notes,
        [type]: value
      }
    }));
  };
  const handleClose = (isChanged) => {
    if (editMode && isChanged) {
      return setShowUnsavedDialog(true);
    }
    onClose();
  }
  const onSave = async (isChanged) => {
    setIsChanged(false);
    const result = await saveMeetingSummary({
      counselorMeetingId: meetingId,
      "counselor": counselingSession.counselor,
      "sessionTime": counselingSession.sessionTime,
      "meetingReasonId": counselingSession.meetingReason,
      "meetingLanguageId": counselingSession.meetingLanguage,
      "studentAttendanceId": counselingSession.studentAttendance,
      "serviceProvidedIds": counselingSession.serviceProvided.join(","),
      "formProvidedIds": counselingSession.formProvided.join(","),
      "tasksForNextMeetingIds": counselingSession.tasksForNextMeeting.join(","),
      "notesToStudent": counselingSession.notes.toStudent,
      "notesToCounselors": counselingSession.notes.toCounselors,
    }, isEdit ? "put" : "post");
    handleClose(isChanged);
  };

  useEffect(() => {
    if (!meetingId) return;
    getMeetingSummary({
      counselorMeetId: meetingId
    }).then((res) => {
      const data = res;
      if (!data.serviceProvidedDetails) {
        data.serviceProvidedDetails = [];
      }
      if (!data.formProvidedDetails) {
        data.formProvidedDetails = [];
      }
      if (!data.tasksForNextMeetingDetails) {
        data.tasksForNextMeetingDetails = [];
      }
      setCounselingSession({
        ...counselingSession,
        ...data,
        meetingReason: data.meetingReasonId,
        meetingLanguage: data.meetingLanguageId,
        studentAttendance: data.studentAttendanceId,
        serviceProvided: (data.serviceProvidedDetails || []).map(a => a.id) || [],
        formProvided: (data.formProvidedDetails || []).map(a => a.id) || [],
        tasksForNextMeeting: (data.tasksForNextMeetingDetails || []).map(a => a.id) || [],
        notes: {
          toStudent: data.notesToStudent,
          toCounselors: data.notesToCounselors
        },
        meetingSummaryId: data.meetingSummaryId,
        sessionTime: calculateDuration(data.meetingStartTime + ' - ' + data.meetingEndTime),

      });
    }).catch((err) => {
      console.log(err);
    });
  }, [meetingId]);

  if (showIncompleteDialog) {
    return <MettingIncompleteDialog
      onClose={() => { setShowIncompleteDialog(false) }}
      onExit={() => {
        onSave();
        onClose();
      }}
    />
  }
  if (showUnsavedDialog) {
    return <UnsavedChangesDialog
      onClose={() => { setShowUnsavedDialog(false) }}
      onExit={onClose}
    />
  }

  return (
    <>
      <Modal
        isOpen={true}
        onRequestClose={() => { }}
        style={customStyles}
        contentLabel="Meeting Summary"
      >
        <div className="meeting-summary-modal">
          <div className="modal-header">
            <h2>Meeting Summary</h2>
            <div className="close-icon" onClick={() => { handleClose(isChanged) }}><CloseIcon /></div>
          </div>

          <div className="meeting-info">
            <div> <span style={{ color: "#1D5EA6", cursor: 'pointer' }}
              onClick={() => {
                // history.push({
                //   pathname: '/studentlist',
                //   studentId: studentId,
                // });
                window.open(
                  `/studentlist?studentId=${studentId}`,
                  '_blank'
                );
                localStorage.setItem('backlink_title_pico', "Calendar");
                localStorage.setItem('backLink_pico', "/calendar");
              }}
            >{fullName}</span> - {format(new Date(...(meetingDate || "").split('-').map((v, i) => i === 1 ? +v - 1 : +v)), 'MMMM dd, yyyy')} <span><img src={meetingType1 === 1 ? VideoIcon : CallIcon} alt="" style={{ margin: "0 6px" }} />{meetingStartTime ? formatTimeRange(meetingStartTime + ' - ' + meetingEndTime).split("-")[0] : ""}</span></div>
          </div>
          <div className='meeting-details' onClick={() => {
            editMode && setIsChanged(true)
          }}>
            <div className="meeting-metadata">
              <div className="metadata-field">
                <label>Counselor</label>
                <p>{counselingSession.counselor}</p>
              </div>

              <div className="metadata-field">
                <label>Session Time</label>
                <p>{counselingSession.sessionTime}</p>
              </div>

              <div className="metadata-field">
                <label>Meeting reason</label>
                {editMode ? (
                  <FormControl variant="outlined" fullWidth size="small">
                    <Select
                      value={counselingSession.meetingReason}
                      onChange={(e) => setCounselingSession(prev => ({ ...prev, meetingReason: e.target.value }))}
                    >
                      {meetingType.map(({ id, name }, index) => (
                        <MenuItem key={id} value={id}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <p>{meetingType.find(type => type.id == counselingSession.meetingReason)?.name || '-'}</p>
                )}
              </div>

              <div className="metadata-field">
                <label>Meeting was conducted in...</label>
                {editMode ? (
                  <FormControl variant="outlined" fullWidth size="small">
                    <Select
                      value={counselingSession.meetingLanguage}
                      onChange={(e) => setCounselingSession(prev => ({ ...prev, meetingLanguage: e.target.value }))}
                    >
                      {meetingLanguage.map(({ id, value }, index) => (
                        <MenuItem key={id} value={id}>
                          {value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <p>{meetingLanguage.find(lang => lang.id == counselingSession.meetingLanguage)?.value || '-'}</p>
                )}
              </div>
              <div className="section">
                <h3 className="section-title">Did the student appear at the meeting?*</h3>
                {editMode ? (
                  <div className="radio-group">
                    {attendance.map(({ id, value }, index) => (
                      <label key={id} className="radio-label">
                        <input
                          type="radio"
                          checked={counselingSession.studentAttendance === id}
                          onChange={() => handleAttendanceChange(id)}
                          name="attendance"
                        />
                        {value}
                      </label>
                    ))}
                  </div>
                ) : (
                  <p>{attendance.find(att => att.id === counselingSession.studentAttendance)?.value || '-'}</p>
                )}
              </div>
            </div>
            <div className="meeting-metadata" style={{ opacity: columns2Disable ? "0.5" : "1" }}>

              <div className="section">
                <h3 className="section-title">Service Provided*</h3>
                {editMode ? (
                  <div className="checkbox-group">
                    {serviceProvider.map(({ id, value }, index) => (
                      <label key={id} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={counselingSession.serviceProvided.includes(id)}
                          onChange={() => handleCheckboxChange('serviceProvided', id, value)}
                          disabled={columns2Disable}
                        />
                        {value}
                      </label>
                    ))}
                  </div>
                ) : (
                  <p>{serviceProvidedDetails.map((a) => a.value).join("\n") || '-'}</p>
                )}


              </div>
              <div className="section">
                <h3 className="section-title">Form Provided*</h3>
                {editMode ? (
                  <div className="checkbox-group">
                    {formProvider.map(({ id, value }, index) => (
                      <label key={id} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={counselingSession.formProvided.includes(id)}
                          onChange={() => handleCheckboxChange('formProvided', id, value)}
                          disabled={columns2Disable}
                        />
                        {value}
                      </label>
                    ))}
                  </div>
                ) : (
                  <p>{formProvidedDetails.map((a) => a.value).join("\n") || '-'}</p>
                )}
              </div>

              <div className="section">
                <h3 className="section-title">
                  Tasks for Next Meeting*
                  <Tooltip title="Students will be sent a reminder notification that these tasks are due before next meeting">
                    <img src={InfoIcon} alt="" />
                  </Tooltip>
                </h3>
                {editMode ? (
                  <div className="checkbox-group">
                    {nextMeeting.map(({ id, value }, index) => (
                      <label key={id} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={counselingSession.tasksForNextMeeting.includes(id)}
                          onChange={() => handleCheckboxChange('tasksForNextMeeting', id, value)}
                          disabled={columns2Disable}
                        />
                        {value}
                      </label>
                    ))}
                  </div>
                ) : (
                  <p>{tasksForNextMeetingDetails.map((a) => a.value).join("\n") || '-'}</p>
                )}
              </div>
            </div>
            <div className="notes-section meeting-metadata">
              <div className="notes-field">
                <label>Notes to student</label>
                {editMode ? (
                  <textarea
                    value={counselingSession.notes.toStudent || ''}
                    onChange={(e) => handleNotesChange('toStudent', e.target.value)}
                    placeholder="Enter notes for the student..."
                  />
                ) : (
                  <p>{counselingSession.notes.toStudent || '-'}</p>
                )}
              </div>

              <div className="notes-field">
                <label>Notes to counselors (Not visible to student)</label>
                {editMode ? (
                  <textarea
                    value={counselingSession.notes.toCounselors || ''}
                    onChange={(e) => handleNotesChange('toCounselors', e.target.value)}
                    placeholder="Enter notes for counselors..."
                  />
                ) : (
                  <p>{counselingSession.notes.toCounselors || '-'}</p>
                )}
              </div>
            </div>
          </div>
          <div className="button-group">
            {editMode ? <> <Button variant="text" onClick={() => { handleClose(isChanged) }} style={{ textTransform: "none" }}>Cancel</Button>
              <Button variant="contained" onClick={() => {
                if (editMode && isNotComplete) {
                  setShowIncompleteDialog(true);
                } else {
                  onSave(false);
                }
              }} style={{ backgroundColor: "#1367B2", color: "white", boxShadow: 'none', borderRadius: "25px", textTransform: "none" }}
              >Save</Button></> :
              <Button variant="contained" onClick={() => { setEditMode(!editMode) }} style={{ backgroundColor: "#1367B2", color: "white", boxShadow: 'none', borderRadius: "25px", textTransform: "none" }}

              >Edit</Button>
            }
          </div>
        </div>
      </Modal>
    </>
  );
}

export default MeetingSummaryModal;